'use client'

import { Center, Container, Flex, Text } from '@chakra-ui/react'
import { BackIcon } from '@/_assets/icon-components'
import { Link } from '@/i18n/navigation'
import { IProps } from './_types'
import Logo from '../Logo'
import { useTranslations } from 'next-intl'
import User from '@/app/[locale]/(home)/_components/Header/_components/User'

const Desktop: React.FC<IProps> = ({ backLink = '', onBack = () => { } }) => {
  const t = useTranslations()
  const BackButton = () => (
    <Center onClick={onBack}>
      <BackIcon color='currentColor' />
    </Center>
  )

  return (
    <Flex
      px={10}
      w={'full'}
      minHeight='96px'
      alignItems={'center'}
      bg={'background.card'}
      justifyContent={'space-between'}
      pt='var(--tg-content-safe-area-inset-top)'
    >
      <Container
        px={10}
        w={'full'}
        maxW={'1360px'}
        minHeight='96px'
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        {backLink ? (
          <Link href={backLink}>
            <Flex color={'text'} gap={2} align='center' onClick={onBack}>
              <BackButton /> <Text>{t('back')}</Text>
            </Flex>
          </Link>
        ) : (
          <Flex cursor={'pointer'} color={'text'} gap={2} align='center' onClick={onBack}>
            <BackButton /> <Text>{t('back')}</Text>
          </Flex>
        )}
        <Center textAlign="center" flexDir="column">
          <Logo />
        </Center>
        <User />
      </Container>
    </Flex>
  )
}

export default Desktop
